import script from "./IpdStatementUpdateTable.vue?vue&type=script&setup=true&lang=js"
export * from "./IpdStatementUpdateTable.vue?vue&type=script&setup=true&lang=js"

import "./IpdStatementUpdateTable.vue?vue&type=style&index=0&id=d69ad602&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d69ad602"]])

export default __exports__